import BodyText from 'LuxKit/Typography/BodyText'
import { formatHotelLoyaltyPointsEarnLabel } from 'lib/hotels/formatHotelLoyaltyPointsEarnLabel'
import React from 'react'

interface Props {
  loyaltyProgramName?: string
}

function HotelLoyaltyPointsEarnLabel(props: Props) {
  const { loyaltyProgramName } = props

  return (
    <BodyText variant="medium" colour="lux-plus" weight="bold" wrap="no-wrap">
      {formatHotelLoyaltyPointsEarnLabel(loyaltyProgramName)}
    </BodyText>
  )
}

export default HotelLoyaltyPointsEarnLabel
